import { toFormData } from "@king-ict/eupisi-ui/utils";

import {
  createBenefitDocument,
  deleteBenefitDocument,
  getBenefitDocument,
} from "../../../api/kindergartenApi";
import BenefitUploadDocument from "../../../models/Benefit/BenefitUploadDocument";
import CriterionDocumentMethodsReturnType from "../../../models/Criterion/CriterionDocumentMethodsReturnType";
import { DocumentDownloadRemoveMethodReturnType } from "../../../models/Request/DocumentMethodsReturnType";
import RequestBenefit from "../../../models/Request/RequestBenefit";
import { RequestDocumentData } from "../../../models/Request/RequestDocumentData";

interface Props {
  benefit: RequestBenefit;
  requestId: number;
  onDocumentsChange: (
    benefit: RequestBenefit,
    documents: RequestDocumentData[]
  ) => void;
  onRemoveDocumentFromList: (
    benefit: RequestBenefit,
    document: RequestDocumentData
  ) => void;
  setDocumentsModalOpenId: Function;
  onCloseDocumentModal: Function;
}

export function useBenefitDocuments(): DocumentDownloadRemoveMethodReturnType;
export function useBenefitDocuments(
  props: Props
): CriterionDocumentMethodsReturnType;
export function useBenefitDocuments(props?: Props) {
  const handleDownloadDocument = (document: RequestDocumentData) => {
    if (document.fileID) {
      getBenefitDocument(document.fileID);
    }
  };

  const handleRemoveDocuments = (documents: RequestDocumentData[]) => {
    let ids = new Array<number>();
    documents.forEach((document) => {
      if (document.id) {
        ids.push(document.id);
      }
    });

    if (ids.length > 0) {
      deleteBenefitDocument(ids);
    }
  };

  if (props) {
    const {
      benefit,
      requestId,
      onDocumentsChange,
      onRemoveDocumentFromList,
      setDocumentsModalOpenId,
      onCloseDocumentModal,
    } = props;

    const handleCloseDocumentsModal = (documents: RequestDocumentData[]) => {
      handleRemoveDocuments(documents);

      onCloseDocumentModal();
    };

    const handleConfirmDocumentsModal = (documents: RequestDocumentData[]) => {
      onDocumentsChange(benefit, documents);

      setDocumentsModalOpenId(undefined);
    };

    const handleUploadDocuments = async (files: File[]) => {
      var documents = await createBenefitDocument(
        toFormData<BenefitUploadDocument>({
          requestId: requestId,
          files: files,
          institutionBenefitId: benefit.institutionBenefitId,
        })
      );
      return documents;
    };

    const handleRemoveDocument = (document: RequestDocumentData) => {
      if (document.id) {
        const ids = [document.id];
        deleteBenefitDocument(ids);
      }
    };

    const handleRemoveDocumentFromList = (document: RequestDocumentData) => {
      onRemoveDocumentFromList(benefit, document);
      handleRemoveDocument(document);
    };

    const handleOpenDocumentsModal = () => {
      setDocumentsModalOpenId(benefit.institutionBenefitId);
    };

    return {
      handleUploadDocuments,
      handleConfirmDocumentsModal,
      handleCloseDocumentsModal,
      handleOpenDocumentsModal,
      handleDownloadDocument,
      handleRemoveDocumentFromList,
      handleRemoveDocument,
      handleRemoveDocuments,
    };
  } else {
    return {
      handleDownloadDocument,
      handleRemoveDocuments,
    };
  }
}
